import { useMutation } from '@tanstack/react-query';
import useApi from '../../../../../../../utils/AxiosWrapper';
import {
  ApiError,
  unwrapApiResponse,
} from '../../../../../../../utils/unwrapApiResponse';

export function useDownloadReportPack() {
  const { callProtectedApi } = useApi();

  return useMutation({
    mutationKey: ['downloadReportPack'],
    mutationFn: async (reportPackId: string) => {
      const response = await callProtectedApi(
        `/accounting/report-packs/${reportPackId}/download`,
        'get'
      );
      // Throws a status/url-tagged ApiError on failure (reaches the global
      // MutationCache reporter) instead of a bare, untagged Error. unwrap only
      // guarantees `data` is present, not `download_url` — a 2xx with a
      // missing/empty url (e.g. pack still generating) must still error rather
      // than open a blank tab.
      const { download_url } = unwrapApiResponse<{ download_url?: string }>(
        response,
        'Failed to load report pack download'
      );
      if (!download_url) {
        // Distinct message + status/url tags so a 2xx-missing-url (e.g. pack
        // still generating) is distinguishable in Sentry from the unwrap
        // failure above, rather than a bare, untagged Error.
        throw new ApiError('Report pack response missing download_url', {
          status: response?.status,
          url: response?.config?.url,
        });
      }
      window.open(download_url, '_blank');
      return download_url;
    },
  });
}
